import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Container from "components/Container"
import theme from "styles/theme"

const EmbedBlock = ({ url, height }) => (
  <Container
    max={942}
    css={{}}
    wrapperStyles={theme.expandQueries({
      backgroundColor: theme.white,
      padding: ["30px 74px 0", "30px 74px 0", "30px 40px 0"],
    })}
  >
    <iframe
      src={url}
      height={height}
      css={{
        display: "block",
        border: 0,
        width: "100%",
      }}
      loading="lazy"
    />
  </Container>
)

export default EmbedBlock

EmbedBlock.propTypes = {
  url: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
}

export const query = graphql`
  fragment EmbedBlock on SanityEmbedBlock {
    url
    height
  }
`
